import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface BreadCrumbState {
    can_show: boolean;
    data: Array<any>;
}

const initialState: BreadCrumbState = {
    can_show: false,
    data: [],
};

const breadCrumbSlice = createSlice({
    name: "breadCrumb",
    initialState,
    reducers: {
        setDataBreadCrumbs: (state, action: PayloadAction<Array<any>>) => {
            state.data = action.payload;
        },
        setShowBreadCrumbs: (state, action: PayloadAction<boolean>) => {
            state.can_show = action.payload;
        },
    },
});

export const {setDataBreadCrumbs, setShowBreadCrumbs} = breadCrumbSlice.actions;

export default breadCrumbSlice.reducer;